export default __webpack_public_path__ + "static/revolutionizing-healthcare-with-implementation-8782609a325631eb9d43c0c050ca23eb.png";